import { Component, Input, OnChanges } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material';

import { MESSAGE_COMMON_ERROR, MESSAGE_EDIT_SUCCESS } from '../../shared/message';
import { Lecture } from '../shared/lecture';
import { LectureService } from '../shared/lecture.service';

@Component({
  selector: 'app-lecture-billing-button',
  templateUrl: './lecture-billing-button.component.html'
})
export class LectureBillingButtonComponent implements OnChanges {
  @Input() lecture: Lecture;
  billing: boolean;

  constructor(private snackBar: MatSnackBar, private lectureService: LectureService) { }

  ngOnChanges() {
    const lecture: Lecture = Object.assign(new Lecture(), this.lecture);
    this.billing = lecture.isBilling();
  }

  onChange(value: boolean, event) {
    if (this.lecture.billing !== value) {
      const changedLecture: Lecture = Object.assign(new Lecture(), this.lecture);
      changedLecture.changeBilling(value);
      this.onSubmit(changedLecture);
    }
  }

  async onSubmit(changedLecture: Lecture) {
    delete changedLecture.ownerObservable;
    try {
      this.lectureService.update(this.lecture.$key, changedLecture);
      this.openSnackBar(MESSAGE_EDIT_SUCCESS);
    } catch (e) {
      this.openSnackBar(MESSAGE_COMMON_ERROR);
    }
  }

  private openSnackBar(message: string, action?: string, config?: MatSnackBarConfig) {
    config = Object.assign(new MatSnackBarConfig(), config, { duration: 3000 });
    this.snackBar.open(message, action, config);
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/lecture-billing-button/lecture-billing-button.component.ts